import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  highlight() {
    console.log('Highlight triggered on:', this.element.id)

    // Remove the class if it exists to allow re-triggering
    this.element.classList.remove("api-key-item-highlight")

    // Force a reflow to restart the animation
    void this.element.offsetWidth

    // Add the highlight class
    this.element.classList.add("api-key-item-highlight")

    console.log('Highlight class added:', this.element.classList.contains("api-key-item-highlight"))
  }

  handleAnimationEnd(event: AnimationEvent) {
    // Clean up animation classes when their animations complete
    if (event.animationName === "apiKeyHighlight") {
      this.element.classList.remove("api-key-item-highlight")
    } else if (event.animationName === "apiKeyFadeIn") {
      this.element.classList.remove("api-key-item-enter")
    }
  }

  connect() {
    this.element.addEventListener("animationend", this.handleAnimationEnd.bind(this))
    this.element.addEventListener("api-key:highlight", this.highlight.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("animationend", this.handleAnimationEnd.bind(this))
    this.element.removeEventListener("api-key:highlight", this.highlight.bind(this))
  }
}
